import type { FC } from 'react';

interface Props {
  showAll?: boolean;
}

const DoctorInfoShimer: FC<Props> = ({ showAll }) => {
  return (
    <div className="animate-pulse flex flex-col gap-y-4">
      <div className="flex items-center gap-x-2 px-4 pt-1 h-full">
        <div className="min-w-[72px] w-[72px] h-[72px] bg-surface-secondary rounded-full" />

        <div className="w-full flex flex-col gap-y-0.5">
          <div className="w-full flex items-center justify-between">
            <div className="h-6 w-28 bg-surface-secondary rounded-full" />
            <div className="h-4 w-20 bg-surface-secondary rounded-full" />
          </div>
          <div className="h-5 w-32 bg-surface-secondary rounded-full" />
          <div className="h-5 w-40 bg-surface-secondary rounded-full" />
          <div className="h-4 w-40 bg-surface-secondary rounded-full" />
        </div>
      </div>

      {showAll && (
        <div className="flex items-center gap-x-2 px-4 mb-2">
          <div className="w-full h-16 flex flex-col items-center justify-center gap-y-1 bg-surface-secondary rounded-lg">
            <div className="h-5 w-12 bg-surface-tertiary rounded-full" />
            <div className="h-5 w-14 bg-surface-tertiary rounded-full" />
          </div>
          <div className="w-full h-16 flex flex-col items-center justify-center gap-y-1 bg-surface-secondary rounded-lg">
            <div className="h-5 w-5 bg-surface-tertiary rounded-full" />
            <div className="h-5 w-14 bg-surface-tertiary rounded-full" />
          </div>
          <div className="w-full h-16 flex flex-col items-center justify-center gap-y-1 bg-surface-secondary rounded-lg">
            <div className="h-5 w-5 bg-surface-tertiary rounded-full" />
            <div className="h-5 w-14 bg-surface-tertiary rounded-full" />
          </div>
        </div>
      )}
    </div>
  );
};

export default DoctorInfoShimer;
